import script from "./DocLibraryMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocLibraryMenu.vue?vue&type=script&setup=true&lang=ts"

import "./DocLibraryMenu.vue?vue&type=style&index=0&id=737a89ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-737a89ae"]])

export default __exports__